import { ReactiveController, ReactiveControllerHost } from 'lit';
import type { StoreApi } from 'zustand/vanilla';

/**
 * Subscribes a Lit host to a Zustand vanilla store.
 * Handles subscribe/unsubscribe via hostConnected/hostDisconnected.
 */
export class StoreController<TState> implements ReactiveController {
  private unsubscribe?: () => void;

  constructor(
    host: ReactiveControllerHost,
    private store: StoreApi<TState>,
    private onChange: (state: TState) => void,
  ) {
    host.addController(this);
  }

  hostConnected(): void {
    this.onChange(this.store.getState());
    this.unsubscribe = this.store.subscribe(this.onChange);
  }

  hostDisconnected(): void {
    this.unsubscribe?.();
    this.unsubscribe = undefined;
  }
}
